import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { PaymentRequestGroupCreditCard } from '../../../components/checkout/payment-request/PaymentRequestGroupCreditCard';
import { checkoutMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
export const PaymentRequestGroupCreditCardContainer = ({ paymentRequestId, group, }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { postRequestSaferpayToken } = checkoutMutations({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: postRequestSaferpayTokenMutation } = useMutation(postRequestSaferpayToken);
    const handleSubmit = (saferpayFieldsToken) => __awaiter(void 0, void 0, void 0, function* () {
        if (saferpayFieldsToken) {
            const response = yield postRequestSaferpayTokenMutation({ paymentRequestId, saferpayFieldsToken });
            if (response === null || response === void 0 ? void 0 : response.redirectUrl) {
                location.href = response.redirectUrl;
            }
        }
    });
    return _jsx(PaymentRequestGroupCreditCard, { group: group, selected: true, onSubmit: handleSubmit });
};
